import { Box, Paper, Stack, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { TemplateType } from '@e-origin/shared';

import { DropdownArrow } from '@components';
import classes from './TemplateTypeView.module.css';

export interface TemplateTypeOption {
  value: TemplateType | 'other';
  label: string;
  'data-pw'?: string;
}

interface TemplateTypeProps {
  templateViewOptions: TemplateTypeOption[];
  value: TemplateType | 'other';
  onChange: (value: TemplateType | 'other') => void;
  title?: string;
}

export const TemplateTypeView: React.FC<TemplateTypeProps> = ({ templateViewOptions, value, onChange, title = 'Template view' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<TemplateTypeOption>(templateViewOptions.find((opt) => opt.value === value));

  const ref = useRef(null);

  const onClickOutside = () => setIsOpen(false);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target) && !event.target.closest('#dropdown-container')) {
      onClickOutside();
    }
  };

  const templateViewSelected = (item: TemplateTypeOption) => {
    if (item.value !== value) {
      onChange(item.value);
      setSelectedOption(item);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <Box className={classes.container} id={`dropdown-container-${title}`} onClick={() => setIsOpen(!isOpen)}>
        <Stack gap={0}>
          <Text c={'#555454'} fz={13}>
            {title}
          </Text>
          <Text c={'#555454'} data-pw="template-dropdown">
            {selectedOption?.label}
          </Text>
        </Stack>
        <DropdownArrow isOpen={isOpen} />

        {isOpen && (
          <Paper className={classes.dropdownList} ref={ref}>
            {templateViewOptions.map((item: any) => {
              return (
                <Box
                  className={classes.dropdownItem}
                  key={item.value}
                  onClick={() => {
                    templateViewSelected(item);
                    setIsOpen(false);
                  }}
                  data-pw={item['data-pw']}
                >
                  <Text c={'#555454'} px={24}>
                    {item.label}
                  </Text>
                </Box>
              );
            })}
          </Paper>
        )}
      </Box>
    </>
  );
};
